module.exports = __webpack_public_path__ + "img/1566268240.397548d2.jpg";